
import { Component, Vue } from 'vue-property-decorator';
import { iColumnTabel } from '@/interface/column';
import { getSimpleNew } from '@/api/statistics';
import UserGeneralView from './user-general-view.vue';
import UserRemain from './user-remain.vue';
@Component({
  components: { UserGeneralView, UserRemain },
})
export default class extends Vue {
  private dataDefault: Date = new Date();
  private dataValue: number = 0;
  private column: iColumnTabel[] = [
    {
      label: '时间',
      prop: 'date',
      isTemp: false,
    },
    {
      label: '用户数',
      prop: 'new_user',
      isTemp: false,
    },
    {
      label: '1日',
      prop: 'day1',
      isTemp: false,
    },
    {
      label: '2日',
      prop: 'day2',
      isTemp: false,
    },
    {
      label: '3日',
      prop: 'day3',
      isTemp: false,
    },
    {
      label: '4日',
      prop: 'day4',
      isTemp: false,
    },
    {
      label: '5日',
      prop: 'day5',
      isTemp: false,
    },
    {
      label: '6日',
      prop: 'day6',
      isTemp: false,
    },
    {
      label: '7日',
      prop: 'day7',
      isTemp: false,
    },
  ];
  private tabelList: {
    title?: string;
    subtitle?: string;
    column: iColumnTabel[];
    tableData: any[];
  }[] = [
    {
      title: '新增/活跃用户概览',
      column: [
        {
          label: '时间',
          prop: 'date',
          isTemp: false,
        },
        {
          label: '新增用户',
          prop: 'new_user',
          isTemp: false,
        },
        {
          label: '活跃用户',
          prop: 'active',
          isTemp: false,
        },
        {
          label: '付费活跃用户',
          prop: 'vip_active',
          isTemp: false,
        },
        {
          label: '体验活跃用户',
          prop: 'free_active',
          isTemp: false,
        },
      ],
      tableData: [],
    },
    {
      title: '用户留存情况',
      subtitle: '新增用户及次日付费留存',
      column: this.column,
      tableData: [],
    },
    {
      subtitle: '客户端活跃用户及留存',
      // column: ['时间', '新增用户', '活跃用户', '付费活跃用户', '体验活跃用户'],
      column: this.column,
      tableData: [],
    },
    {
      subtitle: '付费活跃及留存',
      column: this.column,
      tableData: [],
    },
    {
      subtitle: '体验活跃用户及留存',
      column: this.column,
      tableData: [],
    },
  ];
  dataChange(datavalue: number) {
    this.dataValue = datavalue / 1000;
    this.getSimpleTable();
  }
  async getSimpleTable() {
    try {
      const res = await getSimpleNew({ time: this.dataValue });
      if (res.code == 0) {
        this.tabelList[0].tableData = res.data.summary;
        this.tabelList[1].tableData = res.data.newuser_keepalive;
        this.tabelList[2].tableData = res.data.user_keepalive;
        this.tabelList[3].tableData = res.data.vip_user_keepalive;
        this.tabelList[4].tableData = res.data.free_user_keepalive;
      }
    } catch (error) {
      console.log(error);
    }
  }
  mounted() {
    const start = new Date();
    this.dataValue = Math.round(start.getTime() / 1000);
    // this.getSimpleTable();
  }
}
